import { BaseEntity } from "@app/models/rest/base-entity";
import {
  SkillProfile,
  SkillProfileRuleProjection
} from "@app/models/rest/skill-profile";
import {
  ResourceAvailability,
  ResourceAvailability_DetailProjection
} from "@app/models/rest/resource-availability";
import { Visit, Visit_DetailProjection } from "@app/models/rest/visit";
import { TicketStatus } from "../enums/ticket-status.enum";
import { TicketUpdateSource } from "@app/models/enums/ticket-update-source.enum";
import {
  Resource_BasicProjection,
  ResourceModel
} from "@app/models/rest/resource";
import { TicketCompletionCode } from "@app/models/rest/ticket-completion-code";
import {
  HateoasProjection,
  HateoasResource,
  ProjectionRel,
  ProjectionRelType
} from "@lagoshny/ngx-hateoas-client";

@HateoasResource("tickets")
export class Ticket extends BaseEntity {
  // startTime: Date;
  duration: number;
  ticketStatus: TicketStatus;
  lastUpdateSource: TicketUpdateSource;
  distanceFromPrevious: number;
  despatchedTime: Date;
  enrouteTime: Date;
  arrivedTime: Date;
  startedTime: Date;
  completedTime: Date;
  followOnRequired: boolean;
  followOnActioned: boolean;
  forceStartTime: Date;
  waitingTime: number;
  hideInspection: boolean;
  hideSchedules: boolean;
  hideMaterials: boolean;
  recallPending: boolean;
  @ProjectionRel(TicketCompletionCode)
  ticketCompletionCode: ProjectionRelType<TicketCompletionCode>;
  @ProjectionRel(ResourceModel)
  lockResource: ResourceModel;
}

@HateoasProjection(Ticket, "detail")
export class Ticket_DetailProjection extends BaseEntity {
  duration: number;
  baseDuration: number;
  @ProjectionRel(SkillProfile)
  skillProfile: SkillProfile;
  @ProjectionRel(ResourceAvailability)
  resourceAvailability: ResourceAvailability;
  @ProjectionRel(Visit)
  visit: Visit_DetailProjection;
  ticketStatus: TicketStatus;
  lastUpdateSource: TicketUpdateSource;
  @ProjectionRel(ResourceModel)
  lockToResource: ResourceModel;
  distanceFromPrevious: number;
  despatchedTime: Date;
  enrouteTime: Date;
  arrivedTime: Date;
  startedTime: Date;
  completedTime: Date;
  @ProjectionRel(TicketCompletionCode)
  ticketCompletionCode: ProjectionRelType<TicketCompletionCode>;
  followOnRequired: boolean;
  followOnActioned: boolean;
  forceStartTime: Date;
  waitingTime: number;
  hideInspection: boolean;
  hideSchedules: boolean;
  hideMaterials: boolean;
  recallPending: boolean;
}

@HateoasProjection(Ticket, "basic")
export class Ticket_BasicProjection extends BaseEntity {
  duration: number;
  ticketStatus: TicketStatus;
  resourceAvailability: ResourceAvailability_DetailProjection;
  skillProfile: SkillProfileRuleProjection;
  distanceFromPrevious: number;
  lockToResource: Resource_BasicProjection;
  despatchedTime: Date;
  enrouteTime: Date;
  arrivedTime: Date;
  startedTime: Date;
  completedTime: Date;
  forceStartTime: Date;
  recallPending: boolean;
}
